import * as yup from 'yup';
import { feedConstants } from '../../../../../constants/DataFeed';

const {
  requiredEndpointUrlError,
  requiredEndpointUsername,
  requiredEndpointPassword,
  maxCharLengthError,
  incorrectURLError,
} = feedConstants;

const isValidUrl = (url: any) => {
  if (!url) {
    return false;
  }
  if (url.split(':')[0].toLowerCase() !== 'https') {
    return false;
  }
  return true;
};

export default yup.object().shape({
  endpointUrl: yup
    .string()
    .required(requiredEndpointUrlError)
    .test('is-url-valid', incorrectURLError, (value) => {
      return isValidUrl(value);
    })
    .url(incorrectURLError),
  endpointUsername: yup.string().required(requiredEndpointUsername),
  endpointPassword: yup.string().required(requiredEndpointPassword),
});
